import { Avatar, FlexBox, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import { TagChips } from 'lib-shared-tagging';
import { Tag } from 'lib-shared-types-api';
import { PropsWithClassName } from 'lib-shared-types-utils';

import styles from './conversationPreviewTags.module.scss';

type ConversationPreviewTagsProps = {
  tags: readonly Tag[];
  scrollable?: boolean;
  showSectionIcon?: boolean;
  numberOfTagsToShowInitially?: number;
} & PropsWithClassName;

export const ConversationPreviewTags = ({
  className,
  tags,
  scrollable = false,
  showSectionIcon,
  numberOfTagsToShowInitially = 10,
}: ConversationPreviewTagsProps): JSX.Element | null => {
  if (!tags?.length) {
    return null;
  }

  const rootClass = classnames(
    styles.root,
    {
      [styles.rootScrollable]: scrollable,
    },
    className,
  );

  return (
    <FlexBox
      className={rootClass}
      flexDirection="row"
      gap="200"
      alignItems="flex-start"
    >
      {showSectionIcon && (
        <Tooltip content="Tags">
          <Avatar
            className={styles.icon}
            icon="tag"
            color={{
              contentColor: colors.neutral[700],
              backgroundColor: colors.neutral[100],
            }}
          />
        </Tooltip>
      )}

      <TagChips
        className={styles.tags}
        tags={tags}
        limit={numberOfTagsToShowInitially}
        flexWrap={scrollable ? 'nowrap' : 'wrap'}
      />
    </FlexBox>
  );
};
